/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component, useState } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import i18n from "i18next";
import some from 'lodash/some';

import { Dialog } from 'primereact/dialog';
import { InputText  } from 'primereact/inputtext';
import { Button } from 'primereact/button';

class ModalSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      originalOptionsCheck: [],
      optionsCheck: [],
      deleteOptionsCheck: [],
      mode: 'edit',
      addText: '',
      addValue: '',
      errorsAdd: {}
    }
  }

  componentDidMount() {
    const { target } = this.props
    const getOptions = []
    const getNameInput = target.getAttribute('data-name')
    const getParentId = target.getAttribute('data-parentid')
    const getParentElement = document.getElementById(getParentId)
    const getInputs = getParentElement.querySelectorAll(`input[name='${getNameInput}']`)

    for (let i = 0; i < getInputs.length; i += 1) {
      const getTextLabel = getInputs[i].offsetParent.getElementsByTagName('p')[0].innerHTML
      getOptions.push({text: getTextLabel, value: getInputs[i].value})
    }

    this.setState({
      originalOptionsCheck: [...getOptions],
      optionsCheck: [...getOptions],
      deleteOptionsCheck: [...getOptions],
      loadingPage: false,
    })
  }

  onEdit = async () => {
    const { onEditAction, onHidden } = this.props
    const { optionsCheck, originalOptionsCheck } = this.state
    const validateEmpty = optionsCheck.reduce((empty, item) => {
      if (!item.value) empty = true
      return empty
    }, false)

    if (validateEmpty) return true // No hace accion aceptar hastas que no contenga algun valor vacio
    // Validar si son los mismos valores
    const isSame = originalOptionsCheck.reduce((same, item, index) => {
      if (item.value !== optionsCheck[index].value ) same = false
      return same
    }, true)

    if (isSame) return onHidden()
    onEditAction({optionsCheck})
    return onHidden()
  }

  addOption = async () => {
    const { addText, addValue} = this.state
    const { onAddAction, onHidden } = this.props
    const validate = await this.validateFieldsAdd()
    if (some(validate, {})) return true
    onAddAction(addText, addValue)
    return onHidden()

  }

  deleteOption = async () => {
    const { onDeleteAction, onHidden } = this.props
    const { deleteOptionsCheck, originalOptionsCheck } = this.state

    if (originalOptionsCheck.length === deleteOptionsCheck.length) return onHidden()

    onDeleteAction({deleteOptionsCheck})
    return onHidden()

  }

  validateFieldsAdd = async () => {
    const { t } = this.props
    const { addText, addValue } = this.state
    let errorsAdd = {}
    if (!addText) errorsAdd = {...errorsAdd, [`addText`]: `${t('Texto de la opción')} ${t('es requerido')}`}
    if (!addValue) errorsAdd = {...errorsAdd, [`addValue`]: `${t('Valor')} ${t('es requerido')}`}
    this.setState({errorsAdd})
    return errorsAdd
  }


  onChangeOpt = (option, index) => {
    const { optionsCheck } = this.state
    const newOptions = optionsCheck;
    newOptions[index] = option
    this.setState({optionsCheck:  newOptions })
  }

  onDeleteOpt = (target, index) => {
    const { deleteOptionsCheck } = this.state
    let newOptions = deleteOptionsCheck;
    newOptions = newOptions.filter((item, i) => i !== index)
    // newOptions[index] = target.value
    this.setState({deleteOptionsCheck:  newOptions })
  }

  onChangeSimple = ({target}) => {
    this.setState({[target.name]: target.value}, () => this.validateFieldsOnchange(target.name, target.value))
  }

  validateFieldsOnchange = (name, value) => {
    const { errorsAdd } = this.state
    if (errorsAdd[name] && value) {
      delete errorsAdd[name]
      this.setState({errorsAdd})
    }
  }

  switchMode = (type) => {
    if (type === 'edit') this.setState((prevState ) => ({ optionsCheck: [...prevState.originalOptionsCheck] }))
    if (type === 'delete') this.setState((prevState ) => ({ deleteOptionsCheck: [...prevState.originalOptionsCheck] }))
    this.setState({mode: type})
  }
  
  render () {
    const { t, title, onHidden, label, btnOkLabel, isAddRemoveElements } = this.props
    const { optionsCheck, deleteOptionsCheck, loadingPage, mode, addText, addValue, errorsAdd } = this.state

    const isFormFieldValid = (name) =>
      !!(errorsAdd[name]);
    const getFormErrorMessage = (name) =>
    isFormFieldValid(name) && (
      <small className="p-error">{errorsAdd[name]}</small>
    );

    const renderOptions = optionsCheck.map((item, index) => (
      <div className='p-col-12' key={`${item.text}${index.values}`}>
        <InputsOptions
            value={item}
            key={item}
            onChange={(e) => this.onChangeOpt(e, index)}
            disabledEditValue={!isAddRemoveElements}
        />
      </div>
    ))

    const renderDeleteOptions = deleteOptionsCheck.map((item, index) => {
      const {length} = deleteOptionsCheck
      return (
      <div className="p-col-12 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon cursor-pointer" onClick={length > 1 ? ()=> this.onDeleteOpt(item, index) : () => {}}><i className="pi pi-trash"></i></span>
            <InputText
              value={item.text}
              disabled
            />
        </div>
      </div>
      )
    })

    const formEdit = (
        <div className="p-mt-2 p-fluid p-grid">
        { isAddRemoveElements && (
          <div className='p-col-12 p-d-flex p-jc-end'>
            <Button
              type="button"
              icon="pi pi-plus"
              className="p-button-secondary p-mr-1"
              tooltip={t('Agregar opción')}
              onClick={() => this.switchMode('add')}
            />
            <Button
              type="button"
              icon="pi pi-trash"
              className="p-button-secondary"
              tooltip={t('Eliminar opcion')}
              onClick={() => this.switchMode('delete')}
            />
          </div>
        )}
        <div className="p-col-12">
          <label className="">{t('Configura el valor deseado que tendra cada opción correspondiente. Recuerda que al cambiar el valor de la opción, modificara automaticamente para los demas templates de los otros idiomas')}</label>
        </div>

        <div className='p-col-6'>
          <label className='p-text-bold'>{t('Texto')}</label>
        </div>
        <div className='p-col-6'>
          <label className='p-text-bold'>{t('Valor')}</label>
        </div>

        { renderOptions }

        <div className="p-dialog-footer custom p-col-12">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button>
            { isAddRemoveElements && (
              <button className="p-button p-component" type="button" onClick={this.onEdit}>
                <span className="p-button-label p-c">{btnOkLabel || 'Guardar'}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    )

    const formAdd = (
        <div className="p-mt-2 p-fluid p-grid">
        <div className='p-col-12 p-d-flex p-jc-end'>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-secondary p-mr-1"
            tooltip={t('Editar opciones')}
            onClick={() => this.switchMode('edit')}
          />
          <Button
            type="button"
            icon="pi pi-trash"
            className="p-button-secondary"
            tooltip={t('Eliminar opcion')}
            onClick={() => this.switchMode('delete')}
          />
        </div>
        <div className="p-col-12">
          <label className="">{t('Agregar nueva opción')}</label>
        </div>

        <div className='p-col-12'>
          <label>{t('Texto de la opción')}</label>
          <InputText
            value={addText}
            name="addText"
            onChange={this.onChangeSimple}
          />
          {getFormErrorMessage(`addText`)}
        </div>
        <div className='p-col-12'>
          <label>{t('Valor')}</label>
          <InputText
            value={addValue}
            name="addValue"
            onChange={this.onChangeSimple}
          />
          {getFormErrorMessage(`addValue`)}
        </div>

        <div className="p-dialog-footer custom p-col-12">
          <div>
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button>
            <button className="p-button p-component" type="button" onClick={this.addOption}>
              <span className="p-button-label p-c">{t('Guardar')}</span>
            </button>
          </div>
        </div>
      </div>
    )

    
    const formDelete = (
      <div className="p-mt-2 p-fluid p-grid">
      <div className='p-col-12 p-d-flex p-jc-end'>
        <Button
          type="button"
          icon="pi pi-pencil"
          className="p-button-secondary p-mr-1"
          tooltip={t('Editar opciones')}
          onClick={() => this.switchMode('edit')}
        />
        <Button
          type="button"
          icon="pi pi-plus"
          className="p-button-secondary"
          tooltip={t('Agregar opción')}
          onClick={() => this.switchMode('add')}
        />
      </div>
      <div className="p-col-12">
        <label className="">{label || t('Elimina las opciones que deseas desaparecer')}</label>
      </div>

      { renderDeleteOptions }

      <div className="p-dialog-footer custom p-col-12">
        <div>
          <button className="p-button p-component p-button-raised p-button-secondary p-button-text" type="button" onClick={() => onHidden()}>
            <span className="p-button-label p-c">Cerrar</span>
          </button> 
          <button className="p-button p-component" type="button" onClick={this.deleteOption}>
            <span className="p-button-label p-c">{btnOkLabel || 'Guardar'}</span>
          </button>
        </div>
      </div>
    </div>
  )


    const renderMode = () => {
      switch (mode) {
        case 'edit':
          return formEdit
        case 'add':
          return formAdd
        case 'delete':
          return formDelete
        default:
          break;
      }
    }


    const children = loadingPage ? '' : renderMode() 

    if (loadingPage) return true;

    return (
      <Dialog
        header={title || t('Checkbox')}
        visible
        breakpoints={{'960px': '90vw'}}
        style={{ width: '40vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps))(ModalSelect)



const InputsOptions = ({ value, onChange, disabledEditValue = false }) => {
  const [onValue, setValue] = useState(value)

  return (
    <div className='p-grid'>
      <div className="p-col-6 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon"><i className='pi pi-info'></i></span>
            <InputText
              value={onValue.text}
              onChange={(e) => setValue({...onValue, text: e.target.value})}
              onBlur={() => onChange(onValue)}
              disabled
            />
        </div>
        { ! onValue && <small className="p-error">{i18n.t('Opcion requerida')}</small>}
      </div>
      <div className="p-col-6 p-py-1">
        <div className="p-inputgroup">
            <span className="p-inputgroup-addon">{'< >'}</span>
            <InputText
              value={onValue.value}
              onChange={(e) => setValue({...onValue, value: e.target.value})}
              onBlur={() => onChange(onValue)}
              disabled={disabledEditValue}
            />
        </div>
        { ! onValue && <small className="p-error">{i18n.t('Opcion requerida')}</small>}
      </div>
    </div>
  );
};
